import PageContent from '../components/PageContent';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';

function Coding() {
  return (
    <PageLayout>
      <PageTitle>
        Coding
      </PageTitle>
      <PageContent>
        Stuff about PHP, javascript, React.
      </PageContent>
    </PageLayout>
  );
}

export default Coding;
